import { isEmbeddedSurface } from "@/lib/embedded-surface";

export const GTM_CONTAINER_ID = "GTM-M5N4935R";

type DataLayerWindow = Window & { dataLayer?: unknown[] };

export function loadTagManager(win: Window = window): boolean {
  if (isEmbeddedSurface(win)) return false;
  const doc = win.document;
  const scriptId = `gtm-${GTM_CONTAINER_ID}`;
  if (doc.getElementById(scriptId)) return true;

  const dataLayerWindow = win as DataLayerWindow;
  dataLayerWindow.dataLayer = dataLayerWindow.dataLayer || [];
  dataLayerWindow.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = doc.createElement("script");
  script.id = scriptId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  doc.head.prepend(script);
  return true;
}

export function loadClarity(clarityId: string, win: Window = window): boolean {
  if (!clarityId || isEmbeddedSurface(win)) return false;
  const doc = win.document;
  const scriptId = `clarity-${clarityId}`;
  if (doc.getElementById(scriptId)) return true;

  const script = doc.createElement("script");
  script.id = scriptId;
  script.type = "text/javascript";
  script.textContent = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","${clarityId}");`;
  doc.head.appendChild(script);
  return true;
}
